// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__jBX5f","root":"styles_root__fDk1X"};